import { createFileRoute } from '@tanstack/react-router';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute('/$tenantId/_layout/operating-status/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <DocumentHead
        titleKey="page.operatingStatus.title"
        descriptionKey="page.operatingStatus.description"
      />
      'Hello /_layout/operating-status/!'
    </>
  );
}
